export const STORE_NAME = 'Alpha Import Export'
export const STORE_TAGLINE = 'Premium commodities for global retail & wholesale markets'

// Company registration details (Belgium)
export const COMPANY = {
  legalName: 'Alpha Import & Export B.V.',
  kbo: '0750.943.712',
  euid: 'BEKBOBCE.0750.943.712',
  vat: 'BE0750943712',
  address: 'Kempstraat 14, B-3960 Bree, Belgium',
  phone: '+32 89 00 00 00',
  email: 'trade@alphaimportexport.be',
}

// API configuration — uses the live hosted backend
// In dev, Vite proxies /api to the backend so we avoid CORS.
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? '/api' : 'https://importexportexcellencebv.com/api')
export const API_KEY = import.meta.env.VITE_API_KEY || 'importexports101'

// Legacy bearer token (unused — kept for backward compat)
export const API_TOKEN = import.meta.env.VITE_API_TOKEN || ''

// Admin WhatsApp — quote requests, inquiries and checkout orders are routed here.
// Digits only, international format without '+'. Replace with the real admin number.
export const ADMIN_WHATSAPP = import.meta.env.VITE_ADMIN_WHATSAPP || '3289000000'

// Builds a wa.me deep link with a pre-filled message
export const waLink = (text) =>
  `https://wa.me/${ADMIN_WHATSAPP}?text=${encodeURIComponent(text)}`

// Backend channel slugs/IDs used to differentiate B2C and B2B catalogs.
// The live backend currently has a single "main-website" channel,
// so both segments pull from the same pool and are separated client-side.
export const CHANNELS = {
  retail: 'retail',     // B2C channel slug
  wholesale: 'wholesale' // B2B channel slug
}
